(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["niverto-business-location"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('niverto-location-map')) return;
    class NivertoLocationMap extends HTMLElement {
      connectedCallback() {
        this.showButton = this.querySelector('[data-map-show]');
        this.hideButton = this.querySelector('[data-map-hide]');
        this.frameContainer = this.querySelector('[data-map-frame]');
        this.status = this.querySelector('[role="status"]');
        this.showButton.hidden = false;
        this.onShow = this.onShow || this.showMap.bind(this);
        this.onHide = this.onHide || (() => this.hideMap(true));
        this.onWithdrawal = this.onWithdrawal || (() => this.hideMap(false));
        this.showButton.addEventListener('click', this.onShow);
        this.hideButton.addEventListener('click', this.onHide);
        document.addEventListener('niverto:privacy-withdrawn', this.onWithdrawal);
      }

      disconnectedCallback() {
        this.showButton.removeEventListener('click', this.onShow);
        this.hideButton.removeEventListener('click', this.onHide);
        document.removeEventListener('niverto:privacy-withdrawn', this.onWithdrawal);
        this.hideMap(false);
      }

      showMap() {
        if (this.frameContainer.querySelector('iframe')) return;
        try {
          const url = new URL(this.dataset.mapUrl);
          if (url.origin !== 'https://www.google.com' || url.pathname !== '/maps/embed') throw new Error('invalid-map-url');
          const frame = document.createElement('iframe');
          frame.className = 'nv-location__map';
          frame.title = this.dataset.mapTitle;
          frame.width = '600';
          frame.height = '320';
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.allowFullscreen = true;
          frame.addEventListener('error', () => {
            this.hideMap(false);
            this.status.textContent = this.dataset.error;
          }, { once: true });
          frame.src = url.href;
          this.frameContainer.appendChild(frame);
          this.showButton.hidden = true;
          this.showButton.setAttribute('aria-expanded', 'true');
          this.hideButton.hidden = false;
          this.status.textContent = this.dataset.enabled;
          this.hideButton.focus();
        } catch (_) {
          this.status.textContent = this.dataset.error;
        }
      }

      hideMap(restoreFocus) {
        const hadMap = !!this.frameContainer.querySelector('iframe');
        const focusInside = this.contains(document.activeElement);
        this.frameContainer.replaceChildren();
        this.showButton.hidden = false;
        this.showButton.setAttribute('aria-expanded', 'false');
        this.hideButton.hidden = true;
        if (hadMap) this.status.textContent = this.dataset.disabled;
        if (this.isConnected && (restoreFocus || focusInside)) this.showButton.focus();
      }
    }
    customElements.define('niverto-location-map', NivertoLocationMap);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["niverto-clarity"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.Shopify || window.Shopify.designMode || window.nivertoClarityInitialized) return;
    window.nivertoClarityInitialized = true;
    let loaded = false;
    let withdrawing = false;

    function syncConsent() {
      const privacy = window.Shopify.customerPrivacy;
      if (!privacy || withdrawing) return;
      const allowed = privacy.currentVisitorConsent().analytics === 'yes' && privacy.analyticsProcessingAllowed();

      if (!allowed) {
        if (loaded) {
          withdrawing = true;
          window.clarity('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' });
          window.clarity('stop');
          if (!window.nivertoPrivacyReloading) {
            window.nivertoPrivacyReloading = true;
            window.location.reload();
          }
        }
        return;
      }

      if (loaded) return;
      loaded = true;
      window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
      window.clarity('consentv2', { analytics_Storage: 'granted', ad_Storage: 'denied' });
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/ojj8y5u5la';
      document.head.appendChild(script);
    }

    document.addEventListener('visitorConsentCollected', syncConsent);
    if (window.Shopify.customerPrivacy) {
      syncConsent();
    } else if (typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
        if (!error) syncConsent();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["niverto-privacy-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('niverto-privacy-controls')) return;
    const purposes = ['analytics', 'marketing', 'preferences', 'sale_of_data'];
    let previousConsent = null;
    let apiLoading = null;

    function readConsent() {
      try {
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        return privacy && typeof privacy.currentVisitorConsent === 'function'
          ? { ...privacy.currentVisitorConsent() }
          : null;
      } catch (_) {
        return null;
      }
    }

    function loadConsentApi() {
      if (readConsent()) return Promise.resolve();
      if (apiLoading) return apiLoading;
      apiLoading = new Promise((resolve, reject) => {
        const timeout = window.setTimeout(() => reject(new Error('privacy-api-timeout')), 6000);
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          window.clearTimeout(timeout);
          reject(new Error('privacy-api-unavailable'));
          return;
        }
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
          window.clearTimeout(timeout);
          if (error || !readConsent()) reject(new Error('privacy-api-unavailable'));
          else resolve();
        });
      }).finally(() => { apiLoading = null; });
      return apiLoading;
    }

    function synchronizeConsent() {
      const current = readConsent();
      if (!current) return;
      const withdrawn = previousConsent && purposes.some((purpose) => previousConsent[purpose] === 'yes' && current[purpose] === 'no');
      previousConsent = current;
      if (!withdrawn) return;
      document.dispatchEvent(new CustomEvent('niverto:privacy-withdrawn'));
      if (window.Shopify && window.Shopify.designMode) return;
      if (!window.nivertoPrivacyReloading) {
        window.nivertoPrivacyReloading = true;
        window.location.reload();
      }
    }

    document.addEventListener('visitorConsentCollected', synchronizeConsent);
    previousConsent = readConsent();
    if (!previousConsent) loadConsentApi().then(synchronizeConsent).catch(() => {});

    class NivertoPrivacyControls extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.button.hidden = false;
        this.onClick = this.onClick || this.openPreferences.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button.removeEventListener('click', this.onClick);
      }

      async openPreferences() {
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loading;
        const started = Date.now();
        try {
          if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
            loadConsentApi().catch(() => {});
            while (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
              if (Date.now() - started >= 8000) throw new Error('privacy-banner-unavailable');
              await new Promise((resolve) => window.setTimeout(resolve, 150));
            }
          }
          synchronizeConsent();
          await new Promise((resolve, reject) => {
            const timeout = window.setTimeout(() => reject(new Error('privacy-banner-timeout')), 8000);
            Promise.resolve(window.privacyBanner.showPreferences()).then(
              () => { window.clearTimeout(timeout); resolve(); },
              (error) => { window.clearTimeout(timeout); reject(error); }
            );
          });
          this.status.textContent = '';
        } catch (_) {
          this.status.textContent = this.dataset.error;
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('niverto-privacy-controls', NivertoPrivacyControls);
  })();
  } catch(e) { console.error(e); }
})();

})();
